<template>

  <div>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search...')" />
              <b-button variant="primary" @click="goToAddMembers">
                <span class="text-nowrap">{{ $t('Add Members') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="selectedIds.length" class="mt-1">
          <b-col cols="12" class="d-flex align-items-center justify-content-end">
            <small class="text-muted mr-1">
              {{ selectedIds.length }} {{ $t('selected') }}
            </small>
            <b-button variant="danger" size="sm" @click="removeSelectedFromGroup">
              <feather-icon icon="TrashIcon" size="14" class="mr-25" />
              <span>{{ $t('Remove Selected') }}</span>
            </b-button>
          </b-col>
        </b-row>

      </div>

      <b-table ref="refUserListTable" class="position-relative" :items="items" responsive
        :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
        :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc" :busy="isLoading">

        <template #head(selected)>
          <b-form-checkbox
            :checked="isAllSelectedOnPage"
            :disabled="!items.length"
            @change="toggleSelectAll"
          />
        </template>

        <template #head()="data">
          <span v-if="data.column !== 'selected'" class="text">{{ $t(data.label).toUpperCase() }}</span>
        </template>

        <template #cell(selected)="data">
          <b-form-checkbox
            :checked="isRowSelected(data.item.id)"
            @change="toggleRow(data.item.id)"
          />
        </template>

        <template #cell(fullname)="data">
          <div class="d-flex flex-column">
            <span class="font-weight-bold text-nowrap">{{ data.item.fullname }}</span>
            <small v-if="data.item.username" class="text-muted">{{ data.item.username }}</small>
          </div>
        </template>

        <template #cell(actions)="data">
          <b-button variant="danger" @click="removeFromGroup(data.item)">
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">{{ $t('Remove') }}</span>
          </b-button>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{
              $t('of') }}
              {{ dataMeta.of }}
              {{ $t('entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

            <b-pagination v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import router from '@/router'
import { onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import UsersListFilters from './ClientGroupsListFilters.vue'
import useUsersList from './useClientGroupsList'
import userStoreModule from '../clientGroupStoreModule'
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Swal from 'sweetalert2'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default {

  computed: {


  },
  methods: {
    goToAddMembers() {
      router.push({ name: 'client-group-members-add-page', query: { gid: this.$route.query.gid } })
    },
    removeMembersRequest(memberIds) {
      const groups = [this.$route.query.gid]
      const updateData = {
        members: memberIds,
        groupId: groups,
      }

      return axios({
        method: "post",
        url: `/admin/f/cm/removeMemberFromGroup`,
        data: updateData,
      })
    },
    removeFromGroup(groupInfo) {
      this.removeMembersRequest([groupInfo.id])
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
              text: r.message,
            },
          });
          this.clearSelection();
          this.refetchData();
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
              text: r.message,
            },
          });
        });
    },
    removeSelectedFromGroup() {
      if (!this.selectedIds.length) return

      Swal.fire({
        title: this.$t('Are you sure?'),
        text: this.$t('Selected members will be removed from this group.'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Yes, delete it!'),
        cancelButtonText: this.$t('Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (!result || !result.isConfirmed) return

        this.removeMembersRequest(this.selectedIds.slice())
          .then((r) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Success`,
                icon: "CheckCircleIcon",
                variant: "success",
                text: r.message,
              },
            });
            this.clearSelection();
            this.refetchData();
          })
          .catch((r) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Error`,
                icon: "AlertOctagonIcon",
                variant: "warning",
                text: r.message,
              },
            });
          });
      })
    },
  },

  components: {
    UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  setup() {
    const { t } = useI18nUtils()
    const USER_APP_STORE_MODULE_NAME = 'client-groups'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      fetchGroupMembers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      items,
      isLoading,
      selectedIds,
      isAllSelectedOnPage,
      isRowSelected,
      toggleRow,
      toggleSelectAll,
      clearSelection,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVariantText,
      resolveUserRolesArray,
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList()

    return {
      fetchGroupMembers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      items,
      isLoading,
      selectedIds,
      isAllSelectedOnPage,
      isRowSelected,
      toggleRow,
      toggleSelectAll,
      clearSelection,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVariantText,
      resolveUserRolesArray,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      t,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
